import { useEffect, useRef } from 'react'

export const useIsValueChanged = (value) => {
  const previousValue = useRef(value)

  useEffect(
    () => {
      previousValue.current = value
    },
    [value]
  )

  return previousValue.current !== value
}
